// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".social-links .social-box  {\n    display:inline-block;\n    text-align: center;\n    margin-right: 15px\n}\n", ""]);
// Exports
module.exports = exports;
